/**
 * FacetWP: contact-persons facet interactions.
 *
 * 1. Reset henkilot_ala when parent category changes.
 * 2. Reset henkilot and henkilot_ala when search (henkilot_haku) is used.
 * 3. Reset search when henkilot category is user-selected.
 * 4. Auto-select single parent: when the henkilot facet has only
 *    one option (besides the hidden "All"), select it automatically
 *    and hide the parent facet so only child categories are visible.
 */

(function () {
    let previousValue = "";
    let previousSearch = "";
    let initialized = false;
    // Track programmatic category changes so they don't reset search
    let programmaticCategoryChange = false;

    document.addEventListener("facetwp-refresh", function () {
        if (typeof FWP === "undefined") return;

        // Sync tracking with FacetWP's initial state (handles URL params on page load)
        if (!initialized) {
            initialized = true;
            previousValue = FWP.facets.henkilot?.[0] ?? "";
            previousSearch = FWP.facets.henkilot_haku?.[0] ?? "";
        }

        const currentValue = FWP.facets.henkilot?.[0] ?? "";
        const currentSearch = FWP.facets.henkilot_haku?.[0] ?? "";

        const searchChanged = currentSearch !== previousSearch;
        const categoryChanged = currentValue !== previousValue;

        // Reset subcategory when parent category changes
        if (previousValue !== "" && categoryChanged && "henkilot_ala" in FWP.facets) {
            FWP.facets.henkilot_ala = [];
        }

        // Reset category facets when search is used
        if (currentSearch !== "" && searchChanged) {
            if ("henkilot" in FWP.facets) FWP.facets.henkilot = [];
            if ("henkilot_ala" in FWP.facets) FWP.facets.henkilot_ala = [];
        }
        // Reset search when category is user-selected (not auto-selected)
        else if (categoryChanged && currentValue !== "" && !programmaticCategoryChange) {
            if ("henkilot_haku" in FWP.facets) FWP.facets.henkilot_haku = [];
        }

        previousValue = currentValue;
        previousSearch = currentSearch;
        programmaticCategoryChange = false;
    });

    // After FacetWP renders facets, check if only one parent category exists
    document.addEventListener("facetwp-loaded", function () {
        if (typeof FWP === "undefined") return;

        const parentFacet = document.querySelector(
            ".facetwp-facet-henkilot"
        );
        if (!parentFacet) return;

        // Hide parent category facet when search is active
        const searchActive = (FWP.facets.henkilot_haku?.[0] ?? "") !== "";
        parentFacet.classList.toggle("facetwp-facet--search-active", searchActive);

        // Count visible options (exclude the "All" radio with empty data-value)
        const options = parentFacet.querySelectorAll(
            '.facetwp-radio:not([data-value=""])'
        );

        if (options.length === 1) {
            const singleValue = options[0].getAttribute("data-value");
            const currentValue = FWP.facets.henkilot?.[0] ?? "";

            // Auto-select the only parent if not already selected
            if (currentValue !== singleValue) {
                programmaticCategoryChange = true;
                FWP.facets.henkilot = [singleValue];
                FWP.fetchData();
                return;
            }

            // Hide parent facet — child categories are shown directly
            parentFacet.classList.add("facetwp-facet--single-parent");
        } else {
            parentFacet.classList.remove("facetwp-facet--single-parent");
        }
    });

    // Intercept category facet clicks: if search is active, clear it and
    // force the category selection. This handles the case where FacetWP
    // won't allow selecting a facet with 0 results (due to active search).
    document.addEventListener("click", function (e) {
        const radio = e.target.closest(".facetwp-facet-henkilot .facetwp-radio");
        if (!radio) return;
        if (typeof FWP === "undefined") return;

        const searchValue = FWP.facets.henkilot_haku?.[0] ?? "";
        if (!searchValue) return;

        const clickedValue = radio.getAttribute("data-value") ?? "";
        const currentValue = FWP.facets.henkilot?.[0] ?? "";

        // Only intercept if clicking a different category than current
        if (clickedValue === currentValue) return;

        // Prevent FacetWP's default click handler
        e.stopImmediatePropagation();

        // Clear search, set category, refresh
        FWP.facets.henkilot_haku = [];
        FWP.facets.henkilot = clickedValue ? [clickedValue] : [];
        if ("henkilot_ala" in FWP.facets) FWP.facets.henkilot_ala = [];

        // Update tracking so facetwp-refresh doesn't double-reset
        previousSearch = "";
        previousValue = clickedValue;

        FWP.fetchData();
    }, true); // Use capture phase to fire before FacetWP's handler
})();
